import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper.tsx';
import { useOwnersCenterLogic } from './hooks/useOwnersCenterLogic';
import { OwnersCenterForm } from './OwnersCenterForm/OwnersCenterForm';
import { OwnersCenterProvider } from './context/OwnersCenterContext';

export const OwnersCenter = () => {
  const { t } = useTranslation();

  const { handleSubmit, formMethods, isLoading, contextValue, hasUboFieldErrors } =
    useOwnersCenterLogic();

  return (
    <FormProvider {...formMethods}>
      <OwnersCenterProvider value={contextValue}>
        <StepPageWrapper
          isLoading={isLoading}
          isFormValid={!hasUboFieldErrors}
          handleSubmit={handleSubmit}
          heading={t('sectionTitles.businessDetails')}
          customSubmitTitle={t('pages.ownersCenter.cta')}
          content={t('pages.ownersCenter.title')}
          text={t('pages.ownersCenter.content')}
          textCustomStyle='whitespace-pre-line'
          formMethods={formMethods}>
          <OwnersCenterForm />
        </StepPageWrapper>
      </OwnersCenterProvider>
    </FormProvider>
  );
};
